export default "__VITE_ASSET__DTfq1M5e__"